import {GlobalQuillProvider} from './editor.component';


declare var Quill: any;

const Block
  : { new (any: any), create: (val) => any }
  = Quill.import('blots/embed');

  const Inline
  : { new (any: any), create: (val) => any }
  = Quill.import('blots/inline');

// declare class Block {
//   new(): any,
//   public create()
// }

// declare var GlobalEditorService: any;
export class PlaceholderBlot extends Block {
  static create(data) {
    const node = super['create'](data.label);
    node.innerHTML = PlaceholderBlot.toPlaceholder(data.label);
    node.setAttribute('spellcheck', 'false');
    node.setAttribute('autocomplete', 'off');
    node.setAttribute('autocorrect', 'off');
    node.setAttribute('autocapitalize', 'off');

    // store data
    node.setAttribute('data-label', data.label);
    node.setAttribute('data-id', data.id);
    
    return node;
  }

  static toPlaceholder(text: string): string {
    return `{{ ${text} }}`;
  }

  detach() {
    // GlobalEditorService.onDeleted(this._data);
    // console.log('detached' ,this._data)
    super.detach();
  }

  static value(domNode) {
    const { label, id } = domNode.dataset;
    return { label, id };
  }

  private _quill: any;

  get quill() {
    if (!this._quill) {
      let parent = this.domNode.parentElement;
      // if (!parent) {
      //   console.log('no')
      //   debugger
      // }
      while (!(parent.classList.contains('editor'))) {
        // if (!parent) {
        //   console.log('no')
        //   debugger
        // }
        parent = parent.parentElement;
      }

      let quillId = parent.getAttribute('data-id');
      this._quill = GlobalQuillProvider.get(quillId);
      console.log('fetching quill')
    }

    return this._quill;
  }

  constructor(domNode, value) {
    super(domNode);
    this._data = value;
    this._removedBlot = false;
  }

  // eslint-disable-next-line no-unused-vars
  index(node, offset) {
    // See leaf definition as reference:
    // https://github.com/this.quilljs/parchment/blob/master/src/blot/abstract/leaf.ts
    // NOTE: sometimes `node` contains the actual dom node and sometimes just
    // the text
    return 1;
  }

  /**
   * Replace the current Mention Blot with the given text.
   *
   * @param { String } text the text to replace the mention with.
   */
  _replaceBlotWithText(text) {
    // The steps to replace the Blot with its text must be in this order:
    // 1. insert text - source:API
    //    using API we won't react to changes
    // 2. set selection - source:API
    //    set the cursor position in place
    // 3. remove blot - source:USER
    //    using USER we react to the text-change event and it 'looks' like we
    //    did a blot->text replacement in one step.
    //
    // If we don't do these actions in the specified order, the text update and
    // the cursor position won't be as it should for the autocompletion list.

    if (this._removedBlot) return;
    this._removedBlot = true;
    const cursorPosition = this.quill.getSelection().index;
    const blotCursorPosition = this.quill.selection.getNativeRange().end.offset;
    const realPosition = cursorPosition + blotCursorPosition;

    this.quill.insertText(cursorPosition - 1, text, Quill.sources.API);
    this.quill.setSelection(realPosition - 1, Quill.sources.API);
    this.quill.deleteText(cursorPosition + text.length - 1, 1, Quill.sources.USER);

    // We use API+USER to be able to hook just USER from the outside and the
    // content edit will look like is done in 'one action'.
  }

  changeText(oldText, newText) {
    const name = PlaceholderBlot.toPlaceholder(this._data.label);
    // debugger
    const valid = (oldText == name) && (newText != oldText);
    if (!valid) return;

    let cursorPosition = this.quill.getSelection().index;
    if (cursorPosition == -1) {
      // This case was found just a couple of times and it may not appear again
      // due to improvements made on the MentionBlot. I'm leaving the fix here
      // in case that happens again to debug it.
      cursorPosition = 1;
      console.log('[changeText] cursorPosition was -1 ... changed to 1');
    }

    const blotCursorPosition = this.quill.selection.getNativeRange().end.offset;
    let realPosition = cursorPosition;

    if (!this._removedBlot) {
      realPosition += blotCursorPosition;
    } else {
      // Right after the blot is removed we may need to handle a Mutation.
      // If that's the case, considering that the length of the text is 1 would
      // be wrong since it no longer is an Embed but a text.
      console.log('[changeText] removedBlot is set!');
    }

    if (newText.startsWith(name) && oldText == name) { // append
      // An append happens as follows:
      // Text: <@Name|> -> <@NameX|>
      // We need to move the inserted letter X outside the blot.
      const extra = newText.substr(name.length);

      this.domNode.innerHTML = name;

      // append the text outside the blot
      this.quill.insertText(cursorPosition, extra, Quill.sources.USER);
      this.quill.setSelection(cursorPosition + extra.length, Quill.sources.API);
      // this.quill.insertText(cursorPosition + 2, extra, Quill.sources.USER);
      // this.quill.setSelection(cursorPosition + extra.length + 3, Quill.sources.API);

      return;
    } else if (newText.endsWith(name) && oldText == name) { // prepend
      // A prepend may be handled in two different ways depending on the
      // browser and the text/cursor state.
      //
      // Case A: (not a problem)
      // Text: |<@Name> -> X|<@Name>
      // Case B: (problem)
      // Text: <|@Name> -> <X|@Name>
      //
      // If we reach this point, it means that we need to tackle Case B.
      // We need to move the inserted letter X outside the blot.
      const end = newText.length - name.length;
      const extra = newText.substr(0, end);

      // The cursor position is set right after the inserted character.
      // In some cases the cursor position gets updated before the text-edit
      // event is emited and in some cases afterwards.
      // This difference manifests itself when the Blot is at the beginning and
      // this conditional assignment handles the issue.
      const pos = cursorPosition > 0 ? cursorPosition - 1 : cursorPosition;

      this.domNode.innerHTML = name;

      // append the text outside the blot
      this.quill.insertText(pos, extra, Quill.sources.USER);
      this.quill.setSelection(pos + extra.length, Quill.sources.API);

      return;
    }
    // no append, no prepend, text has changed in a different way.

    // We need to trigger these changes right after the update callback
    // finishes, otherwise errors may appear due to ranges not updating
    // correctly.
    // See: https://github.com/this.quilljs/this.quill/issues/1134
    setTimeout(() => this._replaceBlotWithText(newText), 0)
  }

  update(mutations) {
    // See as reference:
    // https://github.com/this.quilljs/this.quill/blob/develop/blots/cursor.js

    mutations
      .filter(mutation => mutation.type == 'characterData')
      .forEach(m => {
        const oldText = m.oldValue;
        const newText = m.target.data;
        this.changeText(oldText, newText);
      });

    // I'm not sure whether this is needed or not, keeping it just in case.
    super.update(mutations.filter(mutation => mutation.type != 'characterData'));
  }


  blotName = 'holder';
  tagName = 'span';
  className = 'ql-placeholder-content';

  static blotName = 'holder';
  static tagName = 'span';
  static className = 'ql-placeholder-content';
}

PlaceholderBlot.blotName = 'holder'
PlaceholderBlot.tagName = 'span'
PlaceholderBlot.className = 'ql-placeholder-content'


Quill.register({ 'formats/holder': PlaceholderBlot });

export class PlaceholderModule {

  constructor(private quill, private options) {
    // console.log('boom')
    this.quill.on('text-change', this.onTextChange.bind(this));
  }

  onTextChange(_, oldDelta, source) {
    // console.log('changed!')
    let currrentContents = this.quill.getContents();
    let delta = currrentContents.diff(oldDelta);
    (delta.ops as any[])
      .filter(op => op.insert && op.insert.holder)
      // .forEach(op => GlobalQuill.onDeleted.next(op.insert.holder))

    // console.log(delta)
  }
}

Quill.register('modules/holder', PlaceholderModule)

// export class ItpxPlaceholder {

//     private this.quill;
//     private options;

//     constructor(this.quill, options) {
//         this.this.quill = this.quill
//         this.onTextChange = this.onTextChange.bind(this);
//         this.onSelectionChange = this.onSelectionChange.bind(this);

//         this.this.quill.on(Quill.events.TEXT_CHANGE, this.onTextChange)
//         this.this.quill.on(Quill.events.SELECTION_CHANGE, this.onSelectionChange)
//     }

//     onTextChange(_, oldDelta, source) {
//         // console.log('changed bruh')
//     }

//     onSelectionChange(range, oldRange, source) {
//         // console.log('selected bruh')
//     }
// }

export class Counter {

  private quill;
  private options;
  private container;

  constructor(quill: any, options: any) {
    this.quill = this.quill;
    this.options = options;
    this.container = document.querySelector(options.container);
    this.quill.on('text-change', this.update.bind(this));
    this.update();  // Account for initial contents
  }

  calculate() {
    let text = this.quill.getText();
    if (this.options.unit === 'word') {
      text = text.trim();
      // Splitting empty text returns a non-empty array
      return text.length > 0 ? text.split(/\s+/).length : 0;
    } else {
      return text.length;
    }
  }

  update() {
    let length = this.calculate();
    let label = this.options.unit;
    if (length !== 1) {
      label += 's';
    }
    this.container.innerHTML = length + ' ' + label;
  }
}

export class ImageBlot extends Block {
  static create(value) {
    let node = super['create'](value);
    if (typeof value === 'string') {
      node.setAttribute('src', this.sanitize(value));      
    } else {
      node.classList.add('ql-image');
      node.setAttribute('data-id', value.key);
      node.setAttribute('data-label', value.url);

      node.setAttribute('alt', value.alt);
      node.setAttribute('src', value.url);
      
      if (value.width) node.setAttribute('width', value.width + 'px');
      if (value.height) node.setAttribute('height', value.height + 'px');
    }
    return node;
  }

  static sanitize(url) {
    return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
  }

  static value(node) {
    if (node.getAttribute('data-id')) {
      return {
        alt: node.getAttribute('alt'),
        url: node.getAttribute('data-label'),
        key: node.getAttribute('data-id'),
        width: node.getAttribute('width'),
        height: node.getAttribute('height'),
      };
    } else {
      return node.getAttribute('src');
    }
  }

  static blotName = 'image';
  static tagName = 'img';
}

ImageBlot.blotName = 'image';
ImageBlot.tagName = 'img';

Quill.register(ImageBlot);

export class Url extends Inline {
  static create(value) {
    let node = super['create'](value);
    node.classList.add('ql-url');
    if (typeof value === 'string') {
      value = this.sanitize(value);
      node.setAttribute('href', value);      
    } else {
      let url = this.sanitize(value.url);
      node.classList.add('ql-placeholder-url');
      node.setAttribute('href', value.url);
      node.setAttribute('data-id', value.key);
      node.setAttribute('data-label', value.url);
    }

    node.setAttribute('target', '_blank', 'noopener,noreferrer');  
    return node;
  }

  static formats(domNode) {
    if (domNode.getAttribute('data-id')) {
      return {
        key: domNode.getAttribute('data-id'),
        url: domNode.getAttribute('data-label')
      };
    } 

    return domNode.getAttribute('href');
  }

  static sanitize(url) {
    return sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
  }

  format(name, value) {
    if (name !== this.statics.blotName || !value) return super.format(name, value);
    value = this.sanitize(value);
    this.domNode.setAttribute('href', value);
  }

  static blotName = 'link';
  static tagName = 'a';
  static SANITIZED_URL = 'about:blank';
  static PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
}
Url.blotName = 'link';
Url.tagName = 'A';
Url.SANITIZED_URL = 'about:blank';
Url.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];


function sanitize(url, protocols) {
  let anchor = document.createElement('a');
  anchor.href = url;
  let protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

Quill.register(Url);





// WEBPACK FOOTER //
// ./src/app/common/template/editor/placeholder-ext.ts